import { defineComponent as _defineComponent } from 'vue'
import InstallableModuleSetupEditor from './InstallableModuleSetupEditor.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SetupEditorPanel',
  props: {
    hasEditPermissions: { type: Boolean },
    rightMode: { type: Boolean }
  },
  emits: ["closeSideBar"],
  setup(__props: any, { emit }: { emit: ({ (e: 'closeSideBar'): void }), expose: any, slots: any, attrs: any }) {




return { __sfc: true,emit, InstallableModuleSetupEditor }
}

})